var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.674-55.5q-51.942 0-87.243-36.009-35.3-36.009-35.3-86.647V-321h130.63v-573.761l63.326 63.239 63.032-63.239 63.033 63.239 63.032-63.239 63.032 63.239 63.424-63.239 63.136 63.239 63.217-63.239 63.08 63.239 63.797-63.239v716.718q0 50.525-36.079 86.534-36.079 36.01-86.465 36.01H221.674Zm516.152-77.543q18.5 0 31-12.505t12.5-32.095v-613.335H310.065V-271h388.261v92.957q0 19.76 10 32.38 10 12.62 29.5 12.62ZM360.261-629.935v-69.174h239.543v69.174H360.261Zm0 140.37v-69.174h239.543v69.174H360.261Zm331.122-140.37q-14.144 0-24.166-10.605-10.021-10.605-10.021-24.065t9.969-23.982q9.969-10.522 24.185-10.522 14.215 0 24.617 10.47 10.403 10.469 10.403 24 0 13.532-10.422 24.118-10.421 10.586-24.565 10.586Zm0 135.37q-14.144 0-24.166-10.634-10.021-10.635-10.021-24.137 0-13.503 9.969-23.953t24.185-10.45q14.215 0 24.617 10.45 10.403 10.45 10.403 23.953 0 13.502-10.422 24.137-10.421 10.634-24.565 10.634Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.b675115979baef3f5b1f0a3d05dfa7f3.svg";
export { ForwardRef as ReactComponent };